// extracted by mini-css-extract-plugin
export default {"customButton":"CustomButton_customButton__-uQUZ"};